export default "__VITE_ASSET__CwAep43C__"